import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import "./category.css";

export const categories = [
  { label: "الكل", value: "all" },
  { label: "شواء", value: "bbqs" },
  { label: "خبز", value: "breads" },
  { label: "برغر", value: "burgers" },
  { label: "شوكولاتة", value: "chocolates" },
  { label: "حلويات", value: "desserts" },
  { label: "مشروبات", value: "drinks" },
  { label: "دجاج مقلي", value: "fried-chicken" },
  { label: "آيس كريم", value: "ice-cream" },
  { label: "بيتزا", value: "pizzas" },
  { label: "سندويشات", value: "sandwiches" },
  { label: "نقانق", value: "sausages" },
  { label: "ستيك", value: "steaks" }
];

export default function Category({ onSelectCategory }) {
  const [activeCat, setActiveCat] = useState("best-foods");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleSelect = (cat) => {
    // تعيين التصنيف المحدد وتنبيه المكون الأب
    setActiveCat(cat.value);
    if (onSelectCategory) onSelectCategory(cat.value);
    setDropdownOpen(false);
  };

  return (
    <>
      {/* Dropdown للأجهزة الصغيرة */}
      <div className="d-block d-md-none category-dropdown-wrapper px-3 mt-3" dir="rtl">
        <div
          className="dropdown-header"
          onClick={() => setDropdownOpen(!dropdownOpen)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && setDropdownOpen(!dropdownOpen)}
          aria-expanded={dropdownOpen}
        >
          <span>{categories.find((c) => c.value === activeCat)?.label || "الكل"}</span>
          <span className={`arrow ${dropdownOpen ? "rotate" : ""}`}>▼</span>
        </div>

        {dropdownOpen && (
          <ul className="dropdown-list" role="listbox" aria-activedescendant={activeCat}>
            {categories.map((cat) => (
              <li
                key={cat.value}
                onClick={() => handleSelect(cat)}
                role="option"
                aria-selected={activeCat === cat.value}
                tabIndex={0}
                onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && handleSelect(cat)}
              >
                {cat.label}
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* أزرار التصنيفات للأجهزة الكبيرة */}
      <Row className="d-none d-md-flex justify-content-center mt-3 px-2" dir="rtl">
        {categories.map((cat) => (
          <Col xs={6} md={3} lg={2} key={cat.value} className="mb-2 text-center">
            <button
              className={`btn w-100 border ${
                activeCat === cat.value ? "btn-main" : "btn-outline-main"
              }`}
              onClick={() => handleSelect(cat)}
              aria-pressed={activeCat === cat.value}
            >
              {cat.label}
            </button>
          </Col>
        ))}
      </Row>
    </>
  );
}
